<div class="flex flex-col p-3 border border-gray-400 shadow-md rounded-2xl h-full pointer" (click)="openFacebook()">
  <div class="custom-background-color w-12 h-12 p-1 flex justify-center items-center rounded-lg">
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#clip0_465_658)">
        <path fill="white"
          d="M12 2.03998C6.5 2.03998 2 6.52998 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.84998C10.44 7.33998 11.93 5.95998 14.22 5.95998C15.31 5.95998 16.45 6.14998 16.45 6.14998V8.61998H15.19C13.95 8.61998 13.56 9.38998 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96C15.9164 21.5878 18.0622 20.3855 19.6099 18.57C21.1576 16.7546 22.0054 14.4456 22 12.06C22 6.52998 17.5 2.03998 12 2.03998Z"/>
      </g>
      <defs>
        <clipPath id="clip0_465_658">
          <rect width="32" height="25.2632" fill="white" transform="translate(0.222656 0.293121)"/>
        </clipPath>
      </defs>
    </svg>
  </div>
  <dt class="mt-6 text-sm font-bold">Facebook</dt>
  <div class="col-span-2 my-auto">
    <dd class="mt-2 text-sm break-words">{{'detail_modal.info_section.facebook' | translate}}</dd>
  </div>
</div>
